import { useEffect } from 'react'

const SCRIPT_ID = 'meta-pixel-script'
const NOSCRIPT_ID = 'meta-pixel-noscript'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

/**
 * Injects the Meta Pixel (Facebook Pixel) and fires a PageView on mount.
 */
export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    if (!pixelId) return

    if (!window.fbq) {
      const fbq: Window['fbq'] = function (...args: unknown[]) {
        if (fbq!.callMethod) {
          fbq!.callMethod.apply(fbq, args)
        } else {
          fbq!.queue!.push(args)
        }
      } as Window['fbq']

      fbq!.queue = []
      fbq!.loaded = true
      fbq!.version = '2.0'
      fbq!.push = fbq

      window.fbq = fbq
      window._fbq = fbq
    }

    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement('script')
      script.id = SCRIPT_ID
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)
    }

    if (!document.getElementById(NOSCRIPT_ID)) {
      const noscript = document.createElement('noscript')
      noscript.id = NOSCRIPT_ID
      noscript.innerHTML = `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1" />`
      document.body.appendChild(noscript)
    }

    window.fbq?.('init', pixelId)
    window.fbq?.('track', 'PageView')
  }, [pixelId])
}
